(function () {

  const U = () => window.ProductDecoration.utils;
 console.log("starline");
  function calc(ctx) {
    // D-SUFFIX RULE FOR STARLINE ONLY
    const productId = window.productMetafields?.productid || "";
    const isDSuffix = productId.endsWith("D");
    const detail = ctx.detail || {};
    const details = ctx.details || [];
    const qty = Number(ctx.qty || 0);
    const colorCount = Number(ctx.colorCount || 0);
    const imprintLocationCount = detail.imprintLocationCount || (details.findIndex(d => d.sectionKey == detail.sectionKey) + 1);

    const imprintTypes = String(detail.imprint_type || "").toLowerCase();

    const decorationData = ctx.decorationData;
    const matched = U().findDecorationEntry(decorationData, details, detail, imprintTypes);
    const charges = matched?.charges || [];

    const setupList = charges.flat().filter((c) => c?.type === "Setup");
    const runList = charges.flat().filter((c) => c?.type === "Run");

    let setupobj = null;
    let runobj = null;

    // Helpers
    const setupPriceFallback = Number(ctx.setupPrice || 0);
    const runPriceFallback = Number(ctx.runPrice || 0);

    const getSetupUnit = () => Number(setupobj?.price_usd || setupPriceFallback || 0);
    const getRunUnit = () => Number(runobj?.price_usd || runPriceFallback || 0);

    // OVERRIDE: If product ends with D
    if (isDSuffix) {
      setupobj =
        setupList.find((c) => String(c?.y_min_qty) === "*") ||
        U().pickMaxPrice(setupList);
        const setupUnit = getSetupUnit();
        totalSetupCharge = setupUnit * qty,
        totalRunCharge = 0,
        runobj = null

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // 1) Screenprinting / Silkscreen / Drinkware Silkscreen
    if (["screenprinting", "silkscreen", "silkscreen - drinkware"].includes(imprintTypes)) {
      // Setup: usually tiered; safest pick highest (or y_min_qty="*")
      setupobj =
        setupList.find((c) => String(c?.y_min_qty) === "*") ||
        U().pickMaxPrice(setupList);

      // Run: often tiered by x_min_qty (qty tiers). Use closest lower tier.
      const tier = U().closestLowerTierQty(qty, runList);
      runobj =
        runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
        U().pickMaxPrice(runList);

      const setupUnit = getSetupUnit();
      const runUnit = getRunUnit();

      const totalSetupCharge = setupUnit * colorCount;
      const totalRunCharge = runUnit * Math.max(colorCount - 1, 0) * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // 2) Trucolor / Laser / Deboss
    if (["trucolor", "tru.0", "laser", "deboss"].includes(imprintTypes)) {
      setupobj =
        setupList.find((c) => String(c?.y_min_qty) === "*") ||
        U().pickMaxPrice(setupList);

    // Run: often tiered by x_min_qty (qty tiers). Use closest lower tier.
      const tier = U().closestLowerTierQty(qty, runList);
      runobj =
        runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
        U().pickMaxPrice(runList);

      const setupUnit = getSetupUnit();
      const runUnit = getRunUnit();

      const totalSetupCharge = setupUnit;
      const totalRunCharge = runUnit * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    if (imprintTypes === "trucolor - pens") {
      setupobj =
        setupList.find((c) => String(c?.y_min_qty) === "*") ||
        U().pickMaxPrice(setupList);

      const tier = U().closestLowerTierQty(qty, runList);
      runobj =
        runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
        U().pickMaxPrice(runList);

      const setupUnit = getSetupUnit();
      const runUnit = getRunUnit();

      const totalSetupCharge = setupUnit;
      const totalRunCharge = runUnit * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // 3) Digital laminate panel
    if (imprintTypes === "digital laminate panel") {
      setupobj =
        setupList.find((c) => String(c?.y_min_qty) === "*") ||
        U().pickMaxPrice(setupList);

      const tier = U().closestLowerTierQty(qty, runList);
      runobj =
        runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
        U().pickMaxPrice(runList);

      const setupUnit = getSetupUnit();
      const runUnit = getRunUnit();

      const totalSetupCharge = setupUnit;
      const totalRunCharge = runUnit * (Math.max(colorCount - 1, 0)) * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // 4) Embroidery
    if (imprintTypes === "embroidery") {
      setupobj =
        setupList.find((c) => String(c?.y_min_qty) === "*") ||
        U().pickMaxPrice(setupList);

      const tier = U().closestLowerTierQty(qty, runList);
      runobj =
        runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
        U().pickMaxPrice(runList);

      const setupUnit = getSetupUnit();
      const runUnit = getRunUnit();

      const totalSetupCharge = setupUnit;
      const totalRunCharge = runUnit * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // 5) Pad printing
    if (imprintTypes === "pad printing") {
      setupobj =
        setupList.find((c) => String(c?.y_min_qty) === "*") ||
        U().pickMaxPrice(setupList);

      const tier = U().closestLowerTierQty(qty, runList);
      runobj =
        runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
        U().pickMaxPrice(runList);

      const setupUnit = getSetupUnit();
      const runUnit = getRunUnit();

      const totalSetupCharge = setupUnit * colorCount;
      const totalRunCharge = runUnit * Math.max(colorCount - 1, 0) * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // 6) PT embroidery
    if (imprintTypes === "pt embroidery") {
      setupobj =
        setupList.find((c) => String(c?.y_min_qty) === "*") ||
        U().pickMaxPrice(setupList);

      const tier = U().closestLowerTierQty(qty, runList);
      runobj =
        runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
        U().pickMaxPrice(runList);

      const setupUnit = getSetupUnit();
      const runUnit = getRunUnit();

      const totalSetupCharge = setupUnit;
      const totalRunCharge = runUnit * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

    // 6) Laser & Oxidation
    if (imprintTypes === "laser & oxidation") {
      setupobj =
        setupList.find((c) => String(c?.y_min_qty) === "*") ||
        U().pickMaxPrice(setupList);

      const tier = U().closestLowerTierQty(qty, runList);
      runobj =
        runList.find((c) => parseInt(c?.x_min_qty, 10) === tier) ||
        U().pickMaxPrice(runList);

      const setupUnit = getSetupUnit();
      const runUnit = getRunUnit();

      const totalSetupCharge = setupUnit;
      const totalRunCharge = runUnit * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }

      // 6) Laser & Oxidation

    if (imprintTypes?.toLowerCase() === "pt imprint") {
      setupobj =
        setupList?.find((c) => String(c?.y_min_qty) === "*") ||
        U().pickMaxPrice(setupList);

      const tier = U().closestLowerTierQty(qty, runList);

      runobj =
        runList?.find((c) => Number(c?.x_min_qty) === tier) ||
        U().pickMaxPrice(runList);

      const setupUnit = getSetupUnit();
      const runUnit = getRunUnit();

      let totalSetupCharge = setupUnit;
      let totalRunCharge =
        colorCount < 2 ? 0 : runUnit * colorCount * qty;

      return { totalSetupCharge, totalRunCharge, setupobj, runobj };
    }


    // Fallback (still return “best guess objects” if possible)
    setupobj = U().pickMaxPrice(setupList) || null;
    runobj = U().pickMaxPrice(runList) || null;

    return {
      totalSetupCharge: Number(setupPriceFallback || 0),
      totalRunCharge: Number(runPriceFallback || 0) * qty,
      setupobj,
      runobj,
    };
  }

  const supplier = { calcOnQty: calc, calcOnColor: calc };

  window.ProductDecoration.registerSupplier("starline", supplier);
  window.ProductDecoration.registerSupplier("Starline", supplier);

  console.log("Registered Starline supplier handler");
})();
